module.exports = __webpack_public_path__ + "img/gguri_expect.f935e69.png";